/**
 * Link mostrati nel dropdown utente (in alto a destra quando autenticato).
 * Modifica questo file per aggiungere/rimuovere/riordinare le voci.
 *
 * - translationKey: chiave in header.userMenu.* usata per la label localizzata
 * - roles: array di ruoli che vedono il link; [] o omesso = tutti i ruoli
 */

export interface UserMenuLink {
  translationKey: string;  // chiave sotto header.userMenu.*
  href: string;            // URL o path React Router
  external?: boolean;      // true = apre in nuova tab
  icon?: string;           // emoji opzionale
  roles?: string[];        // ruoli autorizzati (vuoto/omesso = tutti)
}

const USER_MENU_LINKS: UserMenuLink[] = [
  {
    translationKey: 'panel',
    href: 'https://my.escortfun.net',
    external: true,
    icon: '🖥️',
    roles: ['model', 'agency', 'user'],
  },
  {
    translationKey: 'profile',
    href: 'https://my.escortfun.net/model-dashboard.php',
    external: true,
    icon: '👤',
    roles: ['model'],
  },
  {
    translationKey: 'shop',
    href: 'https://my.escortfun.net/shop.php',
    external: true,
    icon: '🛍️',
    roles: ['model', 'agency', 'user'],
  },
  {
    translationKey: 'favorites',
    href: '/favorites',
    icon: '❤️',
    roles: [],
  },
];

export default USER_MENU_LINKS;
